import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram } from '@fortawesome/free-brands-svg-icons';

export default function InstagramMetadataIcon() {
  return (
    <div className="itemMetadata-instagramIcon itemMetadata-fontawesome">
      <FontAwesomeIcon icon={faInstagram} />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/conversation_history/conversation_items_v2/message/instagram_metadata_icon.jsx